var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid text-center text-white"},[_c('brand-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }